import { Tooltip } from 'antd';
import React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';
import { redirectToUrl } from 'src/modules/navigation/actions/navigationActions';

import { WebExclusiveBadge } from 'src/modules/programs/components/WebExclusiveBadge';
import { ProgramEnum, ProgramWeekEnum } from '../models/programs';
import {
    getProgramWeekCardIndex,
    getProgramWeekCardUnlockText,
} from '../selectors/programsCardsSelectors';
import {
    isSingleProgramSingleWeekCompleted,
    isSingleProgramSingleWeekLocked,
} from '../selectors/programsSelectors';
import * as S from './styles';

interface StateProps {
    isLocked: boolean;
    isCompleted: boolean;
    formattedWeekIndex: string | undefined;
    unlockText: string | undefined;
}

interface ActionsProps {
    redirectToUrl: typeof redirectToUrl;
}

interface Props extends StateProps, ActionsProps {
    programId: ProgramEnum;
    weekId: ProgramWeekEnum;
    iconUrl: string;
    title: string;
    weekUrl: string;
    webExclusive?: boolean;
}

export class AdditionalProgramWeekCardContainer extends React.PureComponent<Props> {
    private handleOnClick = () => {
        const { isLocked, weekUrl } = this.props;

        if (isLocked) {
            return;
        }

        this.props.redirectToUrl(weekUrl);
    };

    public render(): JSX.Element {
        const {
            iconUrl,
            formattedWeekIndex,
            title,
            isLocked,
            isCompleted,
            unlockText,
            webExclusive,
        } = this.props;

        return (
            <Tooltip placement="bottom" title={isLocked && unlockText}>
                <S.CardWrapper onClick={this.handleOnClick} locked={isLocked}>
                    {webExclusive && <WebExclusiveBadge />}
                    {isLocked && <S.LockIcon />}
                    {isCompleted && <S.CompletedIcon />}
                    <S.CardIcon iconUrl={iconUrl} />
                    <S.CardTitle>{title}</S.CardTitle>
                    {formattedWeekIndex && <S.CardSmallInfo>{formattedWeekIndex}</S.CardSmallInfo>}
                </S.CardWrapper>
            </Tooltip>
        );
    }
}

const mapStateToProps = (state: AppState, { programId, weekId }: Props): StateProps => ({
    isLocked: isSingleProgramSingleWeekLocked(state, programId, weekId),
    isCompleted: isSingleProgramSingleWeekCompleted(state, programId, weekId),
    formattedWeekIndex: getProgramWeekCardIndex(state, programId, weekId),
    unlockText: getProgramWeekCardUnlockText(state, programId, weekId),
});

export const AdditionalProgramWeekCard = connect<StateProps, ActionsProps>(mapStateToProps, {
    redirectToUrl,
})(AdditionalProgramWeekCardContainer);
